import { Injectable } from '@angular/core';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { ApiResponse } from 'src/shared/models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { QualityScoreData } from './quality-score.model';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class QualityScoreService {
    private stateSubject = new BehaviorSubject<any>({});
    public state$ = this.stateSubject.asObservable();

    constructor(
        private cvApiService: CVApiService
    ) {
    }

    setState(key: string, value: any) {
        const currentState = this.stateSubject.value;
        currentState[key] = value;
        this.stateSubject.next(currentState);
    }

    public async LoadQualityScoreData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false): Promise<QualityScoreData> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
        }

        try {
            const url = `/api/v2/dashboards/modules/qualityscore/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<QualityScoreData>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for Quality Score module");
            throw err;
        }
    }

    public async GetQualityScoreDataForExport(moduleKey: string, format: ModuleManagerExportFormat = ModuleManagerExportFormat.Excel, isCXOne: boolean): Promise<ApiResponse<string>> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
        }

        try {
            const url = `/api/v2/dashboards/modules/qualityscore/${encodeURIComponent(moduleKey)}/export?format=${encodeURIComponent(format)}` + `&isCXOne=${isCXOne}`;
            const response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data to export for Quality Score module");
            throw err;
        }
    }
}
